/*
 * Add to cart, without leaving the page.
 *
 * The product form is a native POST to /cart/add that lands on the cart. That
 * still works with this file absent. With it, the same form data goes to
 * /cart/add.js, and the sheet in sections/peanut-cart-sheet.liquid opens to
 * confirm what was added: the pack, the plan, the subtotal, Check out.
 *
 * The sheet's contents come back on the add response itself, through the
 * Section Rendering API's bundled `sections` parameter, so Liquid formats
 * every figure and this file formats none.
 *
 * Anything that goes wrong falls back to the native post: no fetch, a refused
 * add (sold out), a response with no section in it, a browser with no
 * <dialog>. The worst case is the page behaving exactly as it used to.
 */
(function () {
  'use strict';

  var SECTION = 'peanut-cart-sheet';
  var FORM_ID = 'peanut-product-form';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var dialog = document.querySelector('[data-peanut-sheet]');
  if (!dialog || typeof dialog.showModal !== 'function' || !window.fetch) return;

  var adding = false;

  // The same few lines as in peanut-cart.js. The header prints no number for
  // an empty cart, so the first add has to make one.
  function setCount(count) {
    var link = document.querySelector('.peanut-nav__cart');
    if (!link) return;
    var badge = link.querySelector('[data-peanut-cart-count]');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'peanut-nav__cart-count';
        badge.setAttribute('aria-hidden', 'true');
        badge.setAttribute('data-peanut-cart-count', '');
        link.appendChild(badge);
      }
      badge.textContent = count > 99 ? '99+' : String(count);
    } else if (badge) {
      badge.remove();
    }
    link.setAttribute(
      'aria-label',
      count === 0 ? 'Cart, empty' : count === 1 ? 'Cart, 1 item' : 'Cart, ' + count + ' items'
    );
  }

  function setBusy(form, busy) {
    if (window.peanutSubmitState) window.peanutSubmitState.set(form, busy);
  }

  /*
   * Close along the path it came in on. The exit is a transition on a class,
   * and the dialog only really closes when that has finished, or after 320ms
   * if nothing ran: the sheet was told to close before it had moved, or the
   * browser never fires the event.
   *
   * A transition, not a keyframe animation, since 2026-10-11, so closing a
   * sheet that is still sliding in turns it round from where it is.
   *
   * transitionend bubbles, and a button inside the sheet finishing its hover
   * fade would otherwise close the dialog early. Only the dialog's own
   * transition counts: the event's target is the dialog and it has no
   * pseudoElement, which is what the backdrop's fade reports.
   */
  function close() {
    if (!dialog.open || dialog.classList.contains('is-closing')) return;
    dialog.classList.add('is-closing');

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      dialog.removeEventListener('transitionend', onEnd);
      dialog.classList.remove('is-closing');
      dialog.close();
    }
    function onEnd(event) {
      if (event.target === dialog && !event.pseudoElement) finish();
    }
    dialog.addEventListener('transitionend', onEnd);
    window.setTimeout(finish, 320);
  }

  dialog.addEventListener('click', function (event) {
    // A click on the backdrop lands on the dialog element itself; a click
    // inside lands on a descendant.
    if (event.target === dialog) return close();
    if (event.target.closest && event.target.closest('[data-peanut-sheet-close]')) close();
  });

  // Escape fires 'cancel' and would close at once, skipping the exit. Take it
  // through the same door as everything else.
  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    close();
  });

  function open(html, count) {
    var next = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('[data-peanut-sheet-body]');
    var body = dialog.querySelector('[data-peanut-sheet-body]');
    if (!next || !body) return false;

    body.replaceWith(next);
    setCount(count);
    dialog.showModal();

    // Focus the heading, not the close button the browser would pick: a screen
    // reader then starts by saying what happened.
    var title = dialog.querySelector('.peanut-sheet__title');
    if (title) title.focus();
    return true;
  }

  /*
   * Capture phase, on the document, so this runs before the form's own submit
   * listeners. peanut-submit-state.js stands down when it sees the event
   * already prevented, and the busy state is then set from here instead,
   * through the small handle that file exposes.
   */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      // getAttribute, never form.id. The form holds radios named "id", and a
      // named control shadows the property of the same name: form.id is that
      // set of radios, not the string.
      if (!form || !form.getAttribute || form.getAttribute('id') !== FORM_ID) return;

      event.preventDefault();
      if (adding) return;
      adding = true;
      setBusy(form, true);

      var data = new FormData(form);
      data.append('sections', SECTION);
      data.append('sections_url', window.location.pathname);

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add refused');
          return response.json();
        })
        .then(function (result) {
          var html = result.sections && result.sections[SECTION];
          if (!html) throw new Error('no section in response');

          var counted = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-peanut-sheet]');
          var count = counted ? parseInt(counted.getAttribute('data-cart-count'), 10) || 0 : 0;

          if (!open(html, count)) throw new Error('sheet did not open');
          adding = false;
          setBusy(form, false);
        })
        .catch(function () {
          // The item may or may not be in the cart. The native post answers
          // that for the visitor either way: it adds, or it shows Shopify's
          // own error page for a sold out variant.
          adding = false;
          form.submit();
        });
    },
    true
  );
})();
